// 2025 Topps Chrome Star Wars Costco Exclusive
// =============================================================================
// The real Costco SuperBox exclusive: 50 Characters Design Variation cards
// (CE-1..CE-50, eight-parallel rainbow: Refractor, Green /99, Purple /75,
// Gold /50, Orange /25, Black /10, Red /5, Superfractor), the 10 oversized
// Heads Up Die-Cuts (CDC-11..CDC-20, 1 per SuperBox), and the Characters
// Design Variation Autographs (DV-).
// Sources: official Topps Costco Box checklist PDF (card list only) + TCDB
// sid 558995/559285 ("50-card set. 3 packs of 5 cards in each SuperBox from
// Costco"; "Heads Up Die Cuts — 1 per Super Box; Costco exclusive"; Purple
// SN75) + collector confirmation of the parallel ladder (smallwaldo,
// 2026-09-05).
// History: this file previously duplicated all 21 sub-sets of the full 2025
// Chrome checklist. Collector rows on those sub-sets were migrated to
// 2025-chrome (see supabase/migrations/*costco_collector_row_migration.sql)
// BEFORE this trimmed file deployed. Sub-set ids are unchanged (rule 1).
// =============================================================================

export const SETS = [
  {
    id: "characters-design-variation",
    type: "insert",
    title: "COSTCO EXCLUSIVE",
    parallels: [
        { id: "refractor", name: "Refractor", print_run: null, color: "#c8d8f0" },
        { id: "green-refractor", name: "Green Refractor", print_run: 99, color: "#00e676" },
        { id: "purple-refractor", name: "Purple Refractor", print_run: 75, color: "#b060ff" },
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "CE-1", name: "Ahsoka Tano" },
        { n: "CE-2", name: "Bazil DEBUT" },
        { n: "CE-3", name: "Bix Caleen" },
        { n: "CE-4", name: "Bo-Katan Kryze" },
        { n: "CE-5", name: "Boba Fett" },
        { n: "CE-6", name: "Bodhi Rook" },
        { n: "CE-7", name: "C-3PO" },
        { n: "CE-8", name: "Captain Phasma" },
        { n: "CE-9", name: "Cassian Andor" },
        { n: "CE-10", name: "Chewbacca" },
        { n: "CE-11", name: "Chirrut Îmwe" },
        { n: "CE-12", name: "Chopper" },
        { n: "CE-13", name: "Darth Maul" },
        { n: "CE-14", name: "Darth Vader" },
        { n: "CE-15", name: "Emperor Palpatine" },
        { n: "CE-16", name: "Ezra Bridger" },
        { n: "CE-17", name: "Fennec Shand" },
        { n: "CE-18", name: "Fern DEBUT" },
        { n: "CE-19", name: "General Grievous" },
        { n: "CE-20", name: "General Hux" },
        { n: "CE-21", name: "Grand Admiral Thrawn" },
        { n: "CE-22", name: "Grand Moff Tarkin" },
        { n: "CE-23", name: "Greedo" },
        { n: "CE-24", name: "Grogu" },
        { n: "CE-25", name: "Han Solo" },
        { n: "CE-26", name: "Hera Syndulla" },
        { n: "CE-27", name: "Indara DEBUT" },
        { n: "CE-28", name: "Jecki Lon DEBUT" },
        { n: "CE-29", name: "Jod Na Nawood DEBUT" },
        { n: "CE-30", name: "Jyn Erso" },
        { n: "CE-31", name: "KB DEBUT" },
        { n: "CE-32", name: "Kelnacca DEBUT" },
        { n: "CE-33", name: "Kh'ymm DEBUT" },
        { n: "CE-34", name: "Lando Calrissian" },
        { n: "CE-35", name: "Leia Organa" },
        { n: "CE-36", name: "Luke Skywalker" },
        { n: "CE-37", name: "Mace Windu" },
        { n: "CE-38", name: "Neel DEBUT" },
        { n: "CE-39", name: "Obi-Wan Kenobi" },
        { n: "CE-40", name: "Padmé Amidala" },
        { n: "CE-41", name: "Pokkit DEBUT" },
        { n: "CE-42", name: "R2-D2" },
        { n: "CE-43", name: "Sabine Wren" },
        { n: "CE-44", name: "Shin Hati" },
        { n: "CE-45", name: "Sol DEBUT" },
        { n: "CE-46", name: "Supreme Leader Kylo Ren" },
        { n: "CE-47", name: "SM-33 DEBUT" },
        { n: "CE-48", name: "The Mandalorian" },
        { n: "CE-49", name: "The Stranger DEBUT" },
        { n: "CE-50", name: "Yoda" },
    ],
  },
  {
    id: "oversized-heads-up-diecut",
    type: "insert",
    title: "OVERSIZED HEADS UP DIECUT",
    parallels: [
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "CDC-11", name: "Bo-Katan Kryze" },
        { n: "CDC-12", name: "Cassian Andor" },
        { n: "CDC-13", name: "Darth Maul" },
        { n: "CDC-14", name: "Grogu" },
        { n: "CDC-15", name: "Kylo Ren" },
        { n: "CDC-16", name: "Lando Calrissian" },
        { n: "CDC-17", name: "Obi-Wan Kenobi" },
        { n: "CDC-18", name: "Padmé Amidala" },
        { n: "CDC-19", name: "Rey" },
        { n: "CDC-20", name: "Yoda" },
    ],
  },
  {
    id: "characters-design-variation-autographs",
    type: "auto",
    title: "COSTCO EXCLUSIVE AUTOGRAPHS",
    parallels: [
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "DV-AA", name: "Adria Arjona Bix Caleen" },
        { n: "DV-AD", name: "Anthony Daniels C-3PO" },
        { n: "DV-ADD", name: "Adam Driver Supreme Leader Kylo Ren" },
        { n: "DV-CF", name: "Carrie Fisher Leia Organa" },
        { n: "DV-CM", name: "Carrie-Anne Moss Indara DEBUT" },
        { n: "DV-DF", name: "Dave Filoni Chopper" },
        { n: "DV-DG", name: "Domhnall Gleeson General Hux" },
        { n: "DV-DGO", name: "Denise Gough Dedra Meero" },
        { n: "DV-DK", name: "Dafne Keen Jecki Lon DEBUT" },
        { n: "DV-DL", name: "Diego Luna Cassian Andor" },
        { n: "DV-DY", name: "Donnie Yen Chirrut Îmwe" },
        { n: "DV-EE", name: "Eman Esfandi Ezra Bridger" },
        { n: "DV-EM", name: "Ewan McGregor Obi-Wan Kenobi" },
        { n: "DV-FJ", name: "Felicity Jones Jyn Erso" },
        { n: "DV-GC", name: "Gwendoline Christie Captain Phasma" },
        { n: "DV-GE", name: "Giancarlo Esposito Moff Gideon" },
        { n: "DV-GH", name: "Guy Henry Grand Moff Tarkin" },
        { n: "DV-IM", name: "Ian McDiarmid Emperor Palpatine" },
        { n: "DV-IS", name: "Ivanna Sakhno Shin Hati" },
        { n: "DV-JB", name: "Jennifer Beals Garsa Fwip" },
        { n: "DV-JS", name: "Joonas Suotamo Chewbacca" },
        { n: "DV-JSO", name: "Joonas Suotamo Kelnacca DEBUT" },
        { n: "DV-KER", name: "Keri Russell Zorii Bliss" },
        { n: "DV-KS", name: "Katee Sackhoff Bo-Katan Kryze" },
        { n: "DV-KY", name: "Kyle Soller Syril Karn" },
        { n: "DV-LD", name: "Laura Dern Vice Admiral Holdo" },
        { n: "DV-LJ", name: "Lee Jung-jae Sol DEBUT" },
        { n: "DV-LM", name: "Lars Mikkelsen Grand Admiral Thrawn" },
        { n: "DV-MAW", name: "Matthew Wood General Grievous" },
        { n: "DV-MES", name: "Maya Erskine Sully Stark" },
        { n: "DV-MEW", name: "Mary Elizabeth Winstead Hera Syndulla" },
        { n: "DV-MH", name: "Mark Hamill Luke Skywalker" },
        { n: "DV-MJ", name: "Manny Jacinto The Stranger DEBUT" },
        { n: "DV-MW", name: "Ming-Na Wen Fennec Shand" },
        { n: "DV-NB", name: "Natasha Liu Bordizzo Sabine Wren" },
        { n: "DV-NP", name: "Natalie Portman Padmé Amidala" },
        { n: "DV-PB", name: "Paul Blake Greedo" },
        { n: "DV-PP", name: "Pedro Pascal The Mandalorian" },
        { n: "DV-RA", name: "Riz Ahmed Bodhi Rook" },
        { n: "DV-RD", name: "Rosario Dawson Ahsoka Tano" },
        { n: "DV-RP", name: "Ray Park Darth Maul" },
        { n: "DV-SJ", name: "Samuel L. Jackson Mace Windu" },
        { n: "DV-SS", name: "Stellan Skarsgård Luthen Rael" },
        { n: "DV-TM", name: "Temuera Morrison Boba Fett" },
        { n: "DV-TR", name: "Tim Rose Admiral Ackbar" },
        { n: "TV-SW", name: "Simon Williamson Max Rebo" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
